import React from 'react'

const HeaderGeneric = (props) => (
    <header id="header">
        <h1>About Me</h1>
    </header>
)

export default HeaderGeneric
